import { Container } from 'styles/global'
import { useLanguage } from 'languages/language'
import { Detail } from '../detail'
import { ProjectIntro } from '../projectintro'
const UkraineWeapons = () => {
  const { texts } = useLanguage()
  return (
    <Container>
      <ProjectIntro project={texts.ukraineweapons} />
      <Detail
        dir="left"
        media={texts.ukraineweapons.imgs[0]}
        text={texts.ukraineweapons.texts[0]}
      />
      <Detail
        dir="right"
        media={texts.ukraineweapons.imgs[1]}
        text={texts.ukraineweapons.texts[1]}
      />
      <Detail
        dir="left"
        media={texts.ukraineweapons.imgs[2]}
        text={texts.ukraineweapons.texts[2]}
      />
      <Detail
        dir="right"
        media={texts.ukraineweapons.imgs[3]}
        text={texts.ukraineweapons.texts[3]}
      />
      <Detail
        dir="left"
        media={texts.ukraineweapons.imgs[4]}
        text={texts.ukraineweapons.texts[4]}
      />
      <Detail
        dir="right"
        media={texts.ukraineweapons.imgs[5]}
        text={texts.ukraineweapons.texts[5]}
      />
    </Container>
  )
}
export default UkraineWeapons
